var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTkIconBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Catalogue-Retro",
    transform: "translate(-210.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(210.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fillOpacity: 0.475897516,
    fill: "#000000",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(6.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52380952,4.15005189 C8.97330134,4.2001352 8.47066344,4.15005189 7.96802553,3.9747603 C7.89622012,3.94971865 7.8244147,3.9747603 7.75260929,3.99980196 C7.68080388,4.04988527 7.65686874,4.12501023 7.65686874,4.2001352 L7.65686874,9.25854951 C7.65686874,9.28359116 7.65686874,9.30863282 7.6329336,9.33367447 C7.51325791,11.2869236 5.93353878,12.8395062 4.06646122,12.8395062 C2.07984474,12.8395062 0.476190476,11.1617153 0.476190476,9.08325792 C0.476190476,7.13000883 1.8644285,5.52734291 3.70729737,5.35190823 L3.70729737,7.78094877 C3.15678919,7.95624035 2.74989184,8.48211511 2.74989184,9.08311483 C2.74989184,9.83436448 3.3482703,10.4604059 4.06632445,10.4604059 C4.71257318,10.4604059 5.26308136,9.95957275 5.35882192,9.30848972 C5.38275705,9.28344807 5.38275705,9.23336476 5.38275705,9.2083231 L5.38275705,0.49382716 L7.36937353,0.49382716 C7.41724381,0.819368676 7.5369195,1.09482688 7.70446547,1.34524343 C8.11136282,1.9212015 8.82941697,2.22170136 9.52353598,2.04640977 L9.52380952,4.15005189 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkIconBgBlack);
export default __webpack_public_path__ + "static/media/tk-icon-Bg--black.a53df52fdacbdb9183145d83dc8e2ff0.svg";
export { ForwardRef as ReactComponent };